import { createAction, Action } from 'redux-actions'

export const SET_GRADPLANNER_DIRTY = 'GradPlanner/SET_GRADPLANNER_DIRTY'
export const CHANGE_CURRENT_STEP = 'GradPlanner/CHANGE_CURRENT_STEP'
export const CHANGE_REQUIRED_PAGE = 'GradPlanner/CHANGE_REQUIRED_PAGE'
export const CHANGE_CAREER_PATH_REQUIRED_PAGE =
  'GradPlanner/CHANGE_CAREER_PATH_REQUIRED_PAGE'
export const CHANGE_ELECTIVE_PAGE = 'GradPlanner/CHANGE_ELECTIVE_PAGE'
export const CHANGE_PLAN = 'GradPlanner/CHANGE_PLAN'
export const CHANGE_DISTRICT = 'GradPlanner/CHANGE_DISTRICT'
export const CHANGE_SCHOOL = 'GradPlanner/CHANGE_SCHOOL'
export const CHANGE_ENDORSEMENT = 'GradPlanner/CHANGE_ENDORSEMENT'
export const CHANGE_CAREER_PATH = 'GradPlanner/CHANGE_CAREER_PATH'
export const ADD_CORE_CLASS = 'GradPlanner/ADD_CORE_CLASS'
export const REMOVE_CORE_CLASS = 'GradPlanner/REMOVE_CORE_CLASS'
export const ADD_CAREER_PATH_REQUIRED_CLASS =
  'GradPlanner/ADD_CAREER_PATH_REQUIRED_CLASS'
export const REMOVE_CAREER_PATH_REQUIRED_CLASS =
  'GradPlanner/REMOVE_CAREER_PATH_REQUIRED_CLASS'
export const ADD_ELECTIVE_CLASS = 'GradPlanner/ADD_ELECTIVE_CLASS'
export const REMOVE_ELECTIVE_CLASS = 'GradPlanner/REMOVE_ELECTIVE_CLASS'
export const RESET = 'GradPlanner/RESET'
export const SET_SAVED_PLAN = 'GradPlanner/SET_SAVED_PLAN'
export const SET_SUB_STATE = 'GradPlanner/SET_SUB_STATE'
export const CLEAR_SUB_STATES = 'GradPlanner/CLEAR_SUB_STATES'
export const TOGGLE_DISPLAY_REVIEW = 'GradPlanner/TOGGLE_DISPLAY_REVIEW'

export const actions = {
  SET_GRADPLANNER_DIRTY,
  CHANGE_CURRENT_STEP,
  CHANGE_REQUIRED_PAGE,
  CHANGE_CAREER_PATH_REQUIRED_PAGE,
  CHANGE_ELECTIVE_PAGE,
  CHANGE_PLAN,
  CHANGE_DISTRICT,
  CHANGE_SCHOOL,
  CHANGE_ENDORSEMENT,
  CHANGE_CAREER_PATH,
  ADD_CORE_CLASS,
  REMOVE_CORE_CLASS,
  ADD_CAREER_PATH_REQUIRED_CLASS,
  REMOVE_CAREER_PATH_REQUIRED_CLASS,
  ADD_ELECTIVE_CLASS,
  REMOVE_ELECTIVE_CLASS,
  RESET,
  SET_SAVED_PLAN,
  SET_SUB_STATE,
  CLEAR_SUB_STATES,
  TOGGLE_DISPLAY_REVIEW
}
// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
type GradPlannerActionCreators = {
  setDirty: boolean => Action<boolean>,
  changeCurrentStep: number => Action<number>,
  changeRequiredPage: number => Action<number>,
  changeCareerPathRequiredPage: number => Action<number>,
  changeElectivePage: number => Action<number>,
  changePlan: GradPlannerPlan => Action<GradPlannerPlan>,
  changeDistrict: string => Action<string>,
  changeSchool: string => Action<string>,
  changeEndorsement: string => Action<string>,
  changeCareerPath: string => Action<string>,
  changeRequiredCourses: (Array<string>) => Action<Array<string>>,
  addCoreClass: string => Action<string>,
  removeCoreClass: string => Action<string>,
  addCareerPathRequiredClass: string => Action<string>,
  removeCareerPathRequiredClass: string => Action<string>,
  addElectiveClass: string => Action<string>,
  removeElectiveClass: string => Action<string>,
  reset: () => Action,
  setSavedPlan: GradPlannerPlan => Action<GradPlannerPlan>,
  setSubState: () => Action,
  clearSubStates: () => Action,
  toggleDisplayReview: () => Action
}

export const actionCreators: GradPlannerActionCreators = {
  setDirty: createAction(SET_GRADPLANNER_DIRTY),
  changeCurrentStep: createAction(CHANGE_CURRENT_STEP),
  changeRequiredPage: createAction(CHANGE_REQUIRED_PAGE),
  changeCareerPathRequiredPage: createAction(CHANGE_CAREER_PATH_REQUIRED_PAGE),
  changeElectivePage: createAction(CHANGE_ELECTIVE_PAGE),
  changePlan: createAction(CHANGE_PLAN),
  changeDistrict: createAction(CHANGE_DISTRICT),
  changeSchool: createAction(CHANGE_SCHOOL),
  changeEndorsement: createAction(CHANGE_ENDORSEMENT),
  changeCareerPath: createAction(CHANGE_CAREER_PATH),
  addCoreClass: createAction(ADD_CORE_CLASS),
  removeCoreClass: createAction(REMOVE_CORE_CLASS),
  addCareerPathRequiredClass: createAction(ADD_CAREER_PATH_REQUIRED_CLASS),
  removeCareerPathRequiredClass: createAction(
    REMOVE_CAREER_PATH_REQUIRED_CLASS
  ),
  addElectiveClass: createAction(ADD_ELECTIVE_CLASS),
  removeElectiveClass: createAction(REMOVE_ELECTIVE_CLASS),
  reset: createAction(RESET),
  setSavedPlan: createAction(SET_SAVED_PLAN),
  setSubState: createAction(SET_SUB_STATE),
  clearSubStates: createAction(CLEAR_SUB_STATES),
  toggleDisplayReview: createAction(TOGGLE_DISPLAY_REVIEW)
}



// WEBPACK FOOTER //
// ./src/redux/reducers/gradPlanner/gradPlannerActions.js